import { api } from "./paths";

const axios = require("axios");

export async function getBirthPlanQuestions() {
  return axios.get(api.BIRTHPLAN_URL);
}
